<template>
	<v-col>
		<div class="d-flex justify-space-between">
			<div class="font-size-14 font-weight-bold secondary--text">Pertumbuhan Jaringan Ceria</div>
		</div>
		
		<div class="mt-2 d-flex flex-wrap justify-space-between">
			<v-col cols="12" sm="4" md="3" lg="2" class="px-0">
				<v-autocomplete
					placeholder="Pilih Kode Mitra"
					outlined
					dense
					background-color="white"
					class="rounded-xl date-no-border"
					no-data-text="Tidak ada data"
					color="primary"
					hide-details="auto"
					:items="cloneList"
					item-text="network_code"
					item-value="network_code"
					v-model="search.network_code"
					@change="getData()">
				</v-autocomplete>
			</v-col>
		</div>
		<div class="mt-2 mb-5 pb-5" v-if="Object.keys(netgrowData).length > 0">
			<div class="font-size-12 secondary--text mb-5">Pertumbuhan Jaringan Hari Ini</div>
			<div class="d-none d-md-flex flex-row align-center justify-center">
				<div class="d-flex flex-grow-1 flex-shrink-1 mr-2">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-xl text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Penambahan <span class="d-block font-weight-600">Titik Kiri</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netgrowData.master_node_left > 0) ? 'primary--text' : 'grey--text'">{{ netgrowData.master_node_left | toNumber }}</div>
						</div>
					</v-card>
				</div>

				<div class="d-flex flex-grow-1 flex-shrink-1 mx-2">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-xl text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Penambahan <span class="d-block font-weight-600">Titik Kanan</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netgrowData.master_node_right > 0) ? 'primary--text' : 'grey--text'">{{ netgrowData.master_node_right | toNumber }}</div>
						</div>
					</v-card>
				</div>

				<div class="d-flex flex-grow-1 flex-shrink-1 mx-2">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-xl text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Menunggu <span class="d-block font-weight-600">Kiri</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netgrowData.master_wait_left > 0) ? 'primary--text' : 'grey--text'">{{ netgrowData.master_wait_left | toNumber }}</div>
						</div>
					</v-card>
				</div>

				<div class="d-flex flex-grow-1 flex-shrink-1 mx-2">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-xl text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Menunggu <span class="d-block font-weight-600">Kanan</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netgrowData.master_wait_right > 0) ? 'primary--text' : 'grey--text'">{{ netgrowData.master_wait_right | toNumber }}</div>
						</div>
					</v-card>
				</div>

				<div class="d-flex flex-grow-1 flex-shrink-1 mx-2">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-xl text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Penambahan <span class="d-block font-weight-600">Pasangan</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netgrowData.master_match > 0) ? 'primary--text' : 'grey--text'">{{ netgrowData.master_match | toNumber }}</div>
						</div>
					</v-card>
				</div>

				<div class="d-flex flex-grow-1 flex-shrink-1 ml-2">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-xl text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Penambahan <span class="d-block font-weight-600">Sponsor</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netgrowData.master_sponsor > 0) ? 'primary--text' : 'grey--text'">{{ netgrowData.master_sponsor | toNumber }}</div>
						</div>
					</v-card>
				</div>
			</div>

			<v-row class="ml-0 d-flex d-md-none">
				<v-col cols="6" sm="4" class="pl-0">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-xl text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Penambahan <span class="d-block font-weight-600">Titik Kiri</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netgrowData.master_node_left > 0) ? 'primary--text' : 'grey--text'">{{ netgrowData.master_node_left | toNumber }}</div>
						</div>
					</v-card>
				</v-col>

				<v-col cols="6" sm="4" class="pl-0">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-xl text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Penambahan <span class="d-block font-weight-600">Titik Kanan</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netgrowData.master_node_right > 0) ? 'primary--text' : 'grey--text'">{{ netgrowData.master_node_right | toNumber }}</div>
						</div>
					</v-card>
				</v-col>

				<v-col cols="6" sm="4" class="pl-0">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-xl text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Menunggu <span class="d-block font-weight-600">Kiri</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netgrowData.master_wait_left > 0) ? 'primary--text' : 'grey--text'">{{ netgrowData.master_wait_left | toNumber }}</div>
						</div>
					</v-card>
				</v-col>

				<v-col cols="6" sm="4" class="pl-0">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-xl text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Menunggu <span class="d-block font-weight-600">Kanan</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netgrowData.master_wait_right > 0) ? 'primary--text' : 'grey--text'">{{ netgrowData.master_wait_right | toNumber }}</div>
						</div>
					</v-card>
				</v-col>

				<v-col cols="6" sm="4" class="pl-0">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-xl text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Penambahan <span class="d-block font-weight-600">Pasangan</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netgrowData.master_match > 0) ? 'primary--text' : 'grey--text'">{{ netgrowData.master_match | toNumber }}</div>
						</div>
					</v-card>
				</v-col>

				<v-col cols="6" sm="4" class="pl-0">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-xl text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Penambahan <span class="d-block font-weight-600">Sponsor</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netgrowData.master_sponsor > 0) ? 'primary--text' : 'grey--text'">{{ netgrowData.master_sponsor | toNumber }}</div>
						</div>
					</v-card>
				</v-col>
			</v-row>
		</div>

		<div class="mt-5">
			<v-row justify="end">
				<v-col cols="12" sm="11" md="8" xl="5" class="py-0 py-sm-3">
					<v-row justify="end">
						<v-col cols="12" sm="12" md="4" class="pr-2 pr-sm-0 pb-sm-0">
							<v-menu v-model="startDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field placeholder="Dari Tanggal" outlined dense append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" background-color="white" class="rounded-xl date-no-border" hide-details :value="convertDate(start)"></v-text-field>
								</template>
								<v-date-picker locale="id" first-day-of-week="0" color="primary" :max="today" @input="startDate = false" v-model="start"></v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="12" sm="12" md="4" class=" pr-sm-0 pr-xl-2 pb-sm-0">
							<v-menu v-model="endDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field placeholder="Sampai Tanggal" outlined dense append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" background-color="white" class="rounded-xl date-no-border" hide-details :value="convertDate(end)"></v-text-field>
								</template>
								<v-date-picker locale="id" first-day-of-week="0" color="primary" :min="start" :max="today" @input="endDate = false" v-model="end"></v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="12" sm="3" md="3" class="pt-0 pt-sm-3">
							<div class="d-none d-md-flex justify-end">
								<v-btn depressed height="40" color="grey lighten-1" class="mr-3 white--text rounded-xl text-capitalize" @click="resetHistory">Reset</v-btn>
								<v-btn depressed height="40" color="primary" class="white--text rounded-xl text-capitalize" @click="seacrhHistory">Cari</v-btn>
							</div>

							<div class="d-flex d-md-none flex-row">
								<v-btn depressed height="40" color="grey lighten-1" class="mr-3 d-flex flex-grow-1 flex-shrink-1 white--text rounded-xl text-capitalize" @click="resetHistory">Reset</v-btn>
								<v-btn depressed height="40" color="primary" class="d-flex flex-grow-1 flex-shrink-1 white--text rounded-xl text-capitalize" @click="seacrhHistory">Cari</v-btn>
							</div>
						</v-col>
					</v-row>
				</v-col>
			</v-row>

			<div class="mt-3" v-if="!loading">
				<v-row v-if="netgrowList.length > 0">
					<v-col cols="12" class="pt-0 d-none d-md-block">
						<v-simple-table dense class="white-row table-vo table-history-bonus" id="table-netgrowth">
							<template v-slot:default>
								<thead class="grey lighten-2 font-weight-500">
									<tr>
										<th class="text-left py-3" rowspan="2" width="18%">Tanggal</th>
										<th class="text-center mb-0 py-3" colspan="2" width="26%">Penambahan Titik</th>
										<th class="text-center mb-0 py-3" colspan="2" width="26%">Menunggu</th>
										<th class="text-center py-3" rowspan="2" width="10%">Pasangan</th>
										<th class="text-center py-3" rowspan="2" width="10%">Sponsor</th>
									</tr>
									<tr class="grey lighten-1">
										<th class="text-center py-3"><v-icon small color="primary">mdi-arrow-left</v-icon> Kiri</th>
										<th class="text-center py-3">Kanan <v-icon small color="primary">mdi-arrow-right</v-icon></th>
										<th class="text-center py-3"><v-icon small color="primary">mdi-arrow-left</v-icon> Kiri</th>
										<th class="text-center py-3">Kanan <v-icon small color="primary">mdi-arrow-right</v-icon></th>
									</tr>
								</thead>
							</template>
						</v-simple-table>

						<v-simple-table dense class="white-row table-vo table-history-bonus">
							<template v-slot:default>
								<tbody class="grey--text text--darken-3">
									<tr v-for="netGrowth in netgrowList" :key="netGrowth.netgrow_master_id" class="mb-5">
										<td class="text-left" width="18%">
											<div class="d-flex flex-wrap">
												<div class="font-size-20 font-weight-500 primary--text">{{ netGrowth.master_date | toDayNumber }}</div>
												<div class="pl-2 font-size-10 my-auto">
													<div>{{ netGrowth.master_date | toMonth }}</div>
													<div>{{ netGrowth.master_date | toYear }}</div>
												</div>
											</div>
										</td>
										<td class="text-center" width="13%">
											<div>{{ netGrowth.master_node_left | toNumber }}</div>
										</td>
										<td class="text-center" width="13%">
											<div>{{ netGrowth.master_node_right | toNumber }}</div>
										</td>
										<td class="text-center" width="13%">
											<div>{{ netGrowth.master_wait_left | toNumber }}</div>
										</td>
										<td class="text-center" width="13%">
											<div>{{ netGrowth.master_wait_right | toNumber }}</div>
										</td>
										<td class="text-center" width="10%">{{ netGrowth.master_match | toNumber }}</td>
										<td class="text-center" width="10%">{{ netGrowth.master_sponsor | toNumber }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-col>

					<v-col cols="12" class="my-3 d-block d-md-none">
						<template v-for="netGrowth in netgrowList">
							<v-card class="pa-3 mb-2 elevation-0 hover-shadow rounded-xl d-flex flex-row align-start w-100" :key="netGrowth.netgrow_master_id">
								<v-row>
									<v-col cols="4" class="my-auto">
										<div class="d-flex flex-column text-center">
											<div class="font-size-22 font-weight-500 primary--text">{{ netGrowth.master_date | toDayNumber }}</div>
											<div class="font-size-10 my-auto">
												<div>{{ netGrowth.master_date | toMonth }}</div>
												<div>{{ netGrowth.master_date | toYear }}</div>
											</div>
										</div>
									</v-col>

									<v-col cols="8" class="pl-0">
										<div class="d-flex justify-space-between align-start mb-1">
											<label class="cl-black font-size-9 font-weight-bold">Titik Kiri</label>
											<span class="cl-black font-size-10">{{ netGrowth.master_node_left | toNumber }}</span>
										</div>

										<div class="d-flex justify-space-between align-start mb-1">
											<label class="cl-secondary font-size-9 font-weight-bold">Titik Kanan</label>
											<span class="cl-secondary font-size-10">{{ netGrowth.master_node_right | toNumber }}</span>
										</div>

										<div class="d-flex justify-space-between align-start mb-1">
											<label class="cl-black font-size-9 font-weight-bold">Menunggu Kiri</label>
											<span class="cl-black font-size-10">{{ netGrowth.master_wait_left | toNumber }}</span>
										</div>

										<div class="d-flex justify-space-between align-start mb-1">
											<label class="cl-secondary font-size-9 font-weight-bold">Menunggu Kanan</label>
											<span class="cl-secondary font-size-10">{{ netGrowth.master_wait_right | toNumber }}</span>
										</div>

										<div class="d-flex justify-space-between align-start mb-1">
											<label class="cl-black font-size-9 font-weight-bold">Pasangan</label>
											<span class="cl-black font-size-10">{{ netGrowth.master_match | toNumber }}</span>
										</div>

										<div class="d-flex justify-space-between align-start mb-1">
											<label class="cl-black font-size-9 font-weight-bold">Sponsor</label>
											<span class="cl-black font-size-10">{{ netGrowth.master_sponsor | toNumber }}</span>
										</div>
									</v-col>
								</v-row>
							</v-card>
						</template>
					</v-col>
				</v-row>
				<div class="mt-3" v-if="netgrowList.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-xl">
								<NoData></NoData>
								<div class="pt-3 text-center cl-secondary">Tidak ada data pertumbuhan jaringan yang dapat ditampilkan</div>
							</v-card>
						</v-col>
					</v-row>
				</div>
				<div v-if="netgrowList.length > 0">
					<v-row justify="end">
						<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
							<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="netgrowPagination.total_page" @input="changePage"></v-pagination>
						</v-col>
						<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
							<div class=" font-size-10">Menampilkan {{ netgrowPagination.total_display }} data dari total {{ netgrowPagination.total_data }} data</div>
						</v-col>
						<v-col cols="4" sm="2" md="1">
							<v-autocomplete :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" @input="changeLimit"></v-autocomplete>
						</v-col>
					</v-row>
				</div>
			</div>
			<div class="mt-4" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
	components: {
	},
	data() {
		return {
			loading: false,
			startDate: false,
			endDate: false,
			start: moment().format("YYYY-MM-01"),
			end: moment().subtract(1, "days").format("YYYY-MM-DD"),
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			search: {
				network_code: '',
			},
			params: [],
			date: {
				type:'date',
				field:'master_date',
				comparison: 'bet',
				value:''
			},
		}
	},
	computed: {
		...mapState('jaringan', ['netgrowList', 'netgrowPagination', 'netgrowData']),
		...mapState('opsi', ['cloneList']),
	},
	methods: {
		...mapActions('jaringan', ['getNetgrowList']),
		...mapActions('opsi', ['getCloneList']),

		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		seacrhHistory() {
			this.page = 1
			this.getData()
		},
		resetHistory() {
			this.setDefaultRange()
			this.page = 1
			this.limit = '10'
			this.getData()
		},
		setDefaultRange() {
			this.start = moment().format("YYYY-MM-01");
			this.end = moment().subtract(1, "days").format("YYYY-MM-DD");
		},
		getData() {
			this.params = []
			this.loading = true

			this.date.value = this.start + '::' + this.end
			this.params.push(this.date)
			
			this.getNetgrowList(this.queryString({ network_code: this.search.network_code, plan: 'ceria', sort: 'master_date', dir: 'DESC', limit:this.limit, page: this.page, params: this.params })).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Pertumbuhan Jaringan Ceria`)
		await this.getCloneList({ plan: 'ceria' })
		this.getData()
	}
};
</script>

